import React from 'react';

import {
  ArticleTemplateQuery,
  SanityCodeOt,
  SanityContentDualImage,
  SanityContentFloatImage,
  SanityContentHeroImage,
  SanityContentLogoText,
  SanityContentSingleImage,
  SanityContentVideo,
  SanityDualText,
} from '../../../../graphql-types';
import { DualImage } from './dualImage/DualImage';
import { SingleImage } from './singleImage/SingleImage';
import { SingleVideo } from './video/singleVideo';
import { RichText } from '../../../components/2.0version/richText/RichText';
import { DualText } from '../../../components/2.0version/dualText/DualText';
import { usePageContext } from '../../../hooks/contexts/usePageContext';
import { FloatImage } from './floatImage/FloatImage';
import { CodeOt } from './codeOt/CodeOt';
import { DualLogoText } from './dualLogoText/DualLogoText';
import { ContentSeparator } from './contentSeparator/ContentSeparator';

export interface IArticleContentProps {
  content?: NonNullable<ArticleTemplateQuery['sanityBlogArticle']>['content'];
  otList?: ArticleTemplateQuery['allIngenieOt'];
}

export const ArticleContent = ({ content, otList }: IArticleContentProps) => {
  const { lang } = usePageContext();

  return (
    <ul>
      {content &&
        content?.list
          ?.filter((e) => e)
          .map((e, index) => <li key={e?._key ?? index}>{renderContent(e, lang, otList)}</li>)}
    </ul>
  );
};

const renderContent = (
  content: NonNullable<NonNullable<IArticleContentProps['content']>['list']>[0],
  lang: string,
  otList?: ArticleTemplateQuery['allIngenieOt']
) => {
  if (!content) return null;
  switch (content.__typename) {
    case 'SanityContentDualImage':
      return <DualImage data={content as SanityContentDualImage} />;
    case 'SanityContentSingleImage':
      return <SingleImage data={content as SanityContentSingleImage} />;
    case 'SanityContentHeroImage':
      return <SingleImage data={content as SanityContentHeroImage} hero />;
    case 'SanityContentVideo':
      return <SingleVideo data={content as SanityContentVideo} />;
    case 'SanityContentText':
      return <RichText value={content._rawText?.[lang]} />;
    case 'SanityDualText':
      return <DualText dualText={content as SanityDualText} />;
    case 'SanityContentFloatImage':
      return <FloatImage data={content as SanityContentFloatImage} />;
    case 'SanityCodeOt':
      return <CodeOt data={content as SanityCodeOt} otList={otList} />;
    case 'SanityContentLogoText':
      return <DualLogoText data={content as SanityContentLogoText} />;
    case 'SanityContentSeparator':
      return <ContentSeparator />;
    default:
      return null;
  }
};
